/**
 * Gets a CSRF token from cookies
 * 
 * @returns {string|null} - The CSRF token or null if not found
 */
export const getCsrfToken = () => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith('csrftoken=')) {
        cookieValue = decodeURIComponent(cookie.substring('csrftoken='.length));
        break;
      }
    }
  }
  return cookieValue;
};
